export enum StepsToTrack {
  RegisterButtonClicked = "Register button clicked",
  NotRegistering = "User cancelling out of the registration page",
}
